import { useState } from "react";
import { getThemePref, setThemePref, type ThemePref } from "../lib/theme";

const OPTIONS: { value: ThemePref; label: string }[] = [
  { value: "auto", label: "Auto" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];

/** Compact 3-way switch: Auto (follow the device), Light, Dark. Saved on this device. */
export function ThemeSwitch({ className = "" }: { className?: string }) {
  const [pref, setPref] = useState<ThemePref>(getThemePref);
  return (
    <div role="group" aria-label="Colour theme" className={`inline-flex rounded-full border border-line bg-panel p-1 ${className}`}>
      {OPTIONS.map((o) => {
        const on = pref === o.value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={on}
            onClick={() => {
              setPref(o.value);
              setThemePref(o.value);
            }}
            className={`min-h-11 min-w-[3.75rem] rounded-full px-3 text-[13px] font-medium ${
              on ? "bg-soft text-ink" : "text-muted hover:text-ink"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
